import axios from '../lib/axios';
import { FORM_RIDER_DELETE, FORM_RIDER_FIND_MANY } from '../lib/endpoints/rider';

export interface FormRiderModel {
  id: string;
  firstName: string;
  lastName: string;
  gender: string;
  dateOfBirth: string;
  phoneNumber: string;
  secondPhone: string;
  homeAddress: string;
  identityCardPDF: string;
  certificateCurrentHomePDF: string;
  certificateCriminalRecordPDF: string;
  guaranteePDF: string;
  vehicleRegistrationPDF: string;
  confirm: boolean;
  riderRole: string;
  createdAt: string;
  updatedAt: string;
}

export const getFormRiderRegisterData = async (): Promise<FormRiderModel[]> => {
  try {
    const resData = await axios.post(FORM_RIDER_FIND_MANY);
    return resData?.data;
  } catch (err) {
    throw new Error('Failed to fetch form rider data');
  }
};

export const deleteFormRiderRegister = async (id: string) => {
  try {
    await axios.delete(FORM_RIDER_DELETE + id);
  } catch (err) {
    throw new Error('Failed delete form rider');
  }
};
